import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Label,
  Button,
  Select,
  TextArea,
  ModalBody,
  TextInput,
  ModalFooter,
  ModalHeader,
  ModalPortal,
  ModalContent,
  ModalContainer,
  useNotification
} from '@ubisend/pulse-components';
import { PermissionFilter } from '@ubisend/pulse-auth';

import { fetchSitemapUrlAvailableTags } from '../api/index';

const SitemapModal = ({
  handleClose,
  handleSave,
  sitemapUrl,
  setSitemapUrl,
  selectedOption,
  setSelectedOption,
  options,
  isSubmitting
}) => {
  const { showError } = useNotification();

  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const triggerSave = () => {
    if (!isSubmitting) {
      handleSave(selectedTags);
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      triggerSave();
    }
  };
  return (
    <ModalPortal>
      <ModalContainer>
        <ModalContent>
          <ModalHeader>Add URLs</ModalHeader>
          <ModalBody>
            <Flex fat="true" col>
              <Label htmlFor="sitemapType">Type</Label>
              <Select
                id="sitemapType"
                value={selectedOption}
                onChange={e => setSelectedOption(e)}
                options={options}
              />
            </Flex>
            <br />
            <Flex fat="true" col>
              <Label htmlFor="sitemapUrl">URL</Label>
              {sitemapUrl.length > 100 ? (
                <TextArea
                  id="sitemapUrl"
                  value={sitemapUrl}
                  onChange={e => setSitemapUrl(e.target.value)}
                  placeholder="Add URLs e.g. soprano1.com, soprano2.com"
                  rows={4}
                  onKeyDown={handleKeyDown}
                />
              ) : (
                <TextInput
                  id="sitemapUrl"
                  value={sitemapUrl}
                  onChange={e => setSitemapUrl(e.target.value)}
                  placeholder="Add URLs e.g. soprano1.com, soprano2.com"
                  onKeyDown={handleKeyDown}
                />
              )}
            </Flex>
            <br />
            <PermissionFilter can="view generative ai tag">
              {selectedOption?.value === 'url' && (
                <Flex fat="true" col>
                  <Label htmlFor="tagSelect">Tags</Label>
                  <Select
                    id="tagSelect"
                    value={selectedTags.map(tagId => ({
                      label: tags.find(tag => tag.id === tagId)?.name || '',
                      value: tagId
                    }))}
                    onChange={selectedOptions => {
                      const tagIds = selectedOptions.map(option => option.value);
                      setSelectedTags(tagIds);
                    }}
                    options={
                      Array.isArray(tags)
                        ? tags.map(tag => ({
                          label: tag.name,
                          value: tag.id
                        }))
                        : []
                    }
                    placeholder="Select tags (optional)"
                    isMulti={true}
                    onMenuOpen={async () => {
                      try {
                    // Fetch available tags when dropdown opens
                        const availableTagsResponse = await fetchSitemapUrlAvailableTags();
                        const fetchedTags = availableTagsResponse.data.data ?? [];
                        setTags(fetchedTags);
                      } catch (error) {
                        const errorMessage =
                          error.response?.data?.message ||
                          error.message ||
                          'Failed to load tags. Please try again.';
                        showError(errorMessage);
                      }
                    }}
                  />
                </Flex>
              )}
            </PermissionFilter>
          </ModalBody>
          <ModalFooter>
            <Flex right>
              <Flex xSpace>
                <Button
                  variant="secondary"
                  onClick={handleClose}
                  disabled={isSubmitting}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={triggerSave}
                  disabled={isSubmitting}>
                  Save
                </Button>
              </Flex>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
    </ModalPortal>
  );
};

SitemapModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  sitemapUrl: PropTypes.string.isRequired,
  setSitemapUrl: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  setSelectedOption: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};

export default SitemapModal;